// Code generated by Prismic. DO NOT EDIT.

import Achievements from './Achievements';
import AdvantagesOfHeloc from './AdvantagesOfHeloc';
import AnimatedList from './AnimatedList';
import Benefits from './Benefits';
import BorrowMore from './BorrowMore';
import CallToAction from './CallToAction';
import Careers from './Careers';
import Chart from './Chart';
import CompaniesList from './CompaniesList';
import EstimatePayment from './EstimatePayment';
import ExtendedTestimonials from './ExtendedTestimonials';
import FinanceAccess from './FinanceAccess';
import GetFunds from './GetFunds';
import GetOffer from './GetOffer';
import Hero from './Hero';
import IncomeBasedHero from './IncomeBasedHero';
import LoanUses from './LoanUses';
import Modal from './Modal';
import Navigation from './Navigation';
import OfferWallLenders from './OfferWallLenders';
import OurHistory from './OurHistory';
import OurValues from './OurValues';
import PartnerBenefits from './PartnerBenefits';
import PartnerConsumers from './PartnerConsumers';
import PartnerDescription from './PartnerDescription';
import PartnerHero from './PartnerHero';
import PartnerInfoCards from './PartnerInfoCards';
import PartnerList from './PartnerList';
import PartnerPagesList from './PartnerPagesList';
import PersonalLoans from './PersonalLoans';
import PolicyTable from './PolicyTable';
import PrivacyTableTitle from './PrivacyTableTitle';
import ProductsInformation from './ProductsInformation';
import QuestionsAnswers from './QuestionsAnswers';
import RateCalculator from './RateCalculator';
import ServiceAdvantages from './ServiceAdvantages';
import Statistics from './Statistics';
import StatsCard from './StatsCard';
import SwitcherChart from './SwitcherChart';
import TermsInstruction from './TermsInstruction';
import TermsOfServiceHero from './TermsOfServiceHero';
import Testimonials from './Testimonials';
import TextLine from './TextLine';
import TriPointModal from './TriPointModal';

export const components = {
  achievements: Achievements,
  advantages_of_heloc: AdvantagesOfHeloc,
  animated_list: AnimatedList,
  benefits: Benefits,
  borrow_more: BorrowMore,
  call_to_action: CallToAction,
  careers: Careers,
  chart: Chart,
  companies_list: CompaniesList,
  estimate_payment: EstimatePayment,
  extended_testimonials: ExtendedTestimonials,
  finance_access: FinanceAccess,
  get_funds: GetFunds,
  get_offer: GetOffer,
  hero: Hero,
  income_based_hero: IncomeBasedHero,
  loan_uses: LoanUses,
  modal: Modal,
  navigation: Navigation,
  offer_wall_lenders: OfferWallLenders,
  our_history: OurHistory,
  our_values: OurValues,
  partner_benefits: PartnerBenefits,
  partner_consumers: PartnerConsumers,
  partner_description: PartnerDescription,
  partner_hero: PartnerHero,
  partner_info_cards: PartnerInfoCards,
  partner_list: PartnerList,
  partner_pages_list: PartnerPagesList,
  personal_loans: PersonalLoans,
  policy_table: PolicyTable,
  privacy_table_title: PrivacyTableTitle,
  products_information: ProductsInformation,
  questions_answers: QuestionsAnswers,
  rate_calculator: RateCalculator,
  service_advantages: ServiceAdvantages,
  statistics: Statistics,
  stats_card: StatsCard,
  switcher_chart: SwitcherChart,
  terms_instriction: TermsInstruction,
  terms_service_hero: TermsOfServiceHero,
  testimonials: Testimonials,
  text_line: TextLine,
  tri_point_modal: TriPointModal,
};
